import { FunctionComponent } from 'react';
import { Select, SelectProps } from 'antd';
import Search, { SearchProps } from 'antd/lib/input/Search';
import styled from 'styled-components';

import { PackageSearchCategories } from 'leash/types';

export const PackageSearchStyled = styled.div`
  display: flex;
  flex: 1 0;
  justify-content: flex-end;
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PackageSearchInput: FunctionComponent<SearchProps> = styled(Search)`
  width: 20rem;
  margin-right: 1rem;
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const PackageSearchSelect: FunctionComponent<
  SelectProps<PackageSearchCategories>
> = styled(Select)`
  width: 10rem;
  margin-right: 1rem;
`;
